import { useNavigate, useParams } from "react-router-dom";

import { PublicTermPurpose } from "../../../services/etcServices";

import StickyHeader from "../../../components/Layout/StickyHeader";

import useTerms from "../../../hooks/useTerms";

type Props = {};

export default function PastTerms(props: Props) {
  const params = useParams();
  const navigate = useNavigate();

  const [, termsVersionComponent] = useTerms({
    purpose: params.purpose as PublicTermPurpose,
    isPopup: false,
  });

  return (
    <>
      <div className="px-[20px]">
        <StickyHeader
          title="이전 약관 목록"
          onBackClick={() => navigate("/myinfo/config")}
        />
      </div>

      {termsVersionComponent}
    </>
  );
}
